import { useEffect, useState } from 'react'
import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { useMediaQuery } from 'react-responsive'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import { use100vh } from 'react-div-100vh'

import styles from './style.module.css'
import { useJobSearch } from '@src/state/jobSearch'
import { getCandidateById } from 'queries'
import { useAuth } from '@src/auth'
import jobFilters from '@components/MobileFilter/filters.json'
import { DEFAULT_DATE_POSTED } from '@src/constants'
import { searchJobs, searchJobsByLocation } from '@src/graphqlqueries'
import { searchJobsByTerm } from '@src/graphqlqueries'

const MobileSearch = dynamic(() => import('@components/MobileSearch'))
const Loader = dynamic(() =>
  import('semantic-ui-react/dist/commonjs/elements/Loader'),
)
const FilterBar = dynamic(() => import('@components/FilterBar'), {
  ssr: true,
})
const JobsViewer = dynamic(() => import('../../components/JobsViewer/index'), {
  ssr: false,
})

export default function JobsPage({ jobPostings, applicationMap, staticJobs, staticParams }) {
  const { state, dispatch } = useJobSearch()
  const router = useRouter()
  const [jobSeekerId, setJobSeekerId] = useState(null)
  const [page, setPage] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [staticList, setStaticList] = useState(staticJobs ?? null)
  const [jobs, setJobs] = useState(staticJobs ? staticJobs : [])
  const [updates, setUpdates] = useState(staticJobs?.length ? 2 : 0);
  const filterOptions = getFilterOptions(router)
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 820px)' })
  const mobileHeight = use100vh()
  const { user } = useAuth()

  const { data: userData, loading: userLoading, error } = useQuery(
    gql(getCandidateById),
    {
      variables: { userId: user?.username },
    },
  )

  useEffect(() => {
    let map = {}
    const applications = userData?.getUserById?.jobSeeker?.applications ?? []

    applications.forEach((app) => {
      map[app?.jobId] = true
    })
    const seekerId = userData?.getUserById?.jobSeeker?.id
    setJobSeekerId(seekerId)
    setJobs(jobsWithAppliedStatus(jobs, map))
  }, [userData])

  const [getJobsStandard, { data, loading, error: searchError }] = useLazyQuery(
    gql(searchJobs),
    {
      fetchPolicy: 'network-only',
    },
  )

  const [getJobsByTerm, { data: termSearchData, loading: termSearchLoading, error: termSearchError }] = useLazyQuery(
    gql(searchJobsByTerm),
    {
      fetchPolicy: 'network-only',
    },
  )

  const [getJobsByLocation, { data: locationSearchData, loading: locationSearchLoading, error: locationSearchError }] = useLazyQuery(
    gql(searchJobsByLocation),
    {
      fetchPolicy: 'network-only',
    },
  )    

  function getJobs(state, vars) {
    console.log('get jobs called!')
    console.log('state: ', state)
    console.log('vars: ', vars)

    if (state?.location?.formatted_address?.length && state?.searchTerm?.length) {
      console.log('get jobs by location and term')
      getJobsStandard(vars)
    } else if (state?.searchTerm?.length) {
      console.log('get jobs by term')
      getJobsByTerm(vars)
    } else if (state?.location?.formatted_address?.length) {
      console.log('get jobs by location')
      getJobsByLocation(vars)
    }
  }

  const updateQueryString = () => {
    console.log('update query string!')

    setUpdates(updates - 1);
    let queryString = `search=${state?.searchTerm}`
    let filters = Object.keys(state?.filterStates)
    let filterString = ''
    filters.forEach((filter) => {
      if (state?.filterStates?.[filter] === false) {
        filterString = filterString.concat(`&${filter}=false`)
      }
    })
    queryString = queryString.concat(filterString)

    if (
      state.location?.formatted_address &&
      state.location?.coordinate?.lon &&
      state.location?.coordinate?.lat &&
      state.location?.regions?.region &&
      state.location?.regions?.country &&
      state.location?.regions?.area
    ) {
      const locationStr = `&location=${state.location.formatted_address}&area=${state.location?.regions?.area}&region=${state?.location.regions.region}&country=${state.location.regions.country}&lat=${state.location?.coordinate?.lat}&lon=${state.location?.coordinate?.lon}`
      queryString = queryString.concat(locationStr)
    } else {
    }
    let path = `/jobs/?${queryString}`

    console.log('static jobs: ', staticJobs)
    if (staticJobs) {
      path = `/jobs/search/?${queryString}`
    }

    console.log('path: ', path)

    router.push(path, undefined, {
      shallow: true,
    })
  }

  useEffect(() => {
    console.log('jobs page on mount')
    console.log('router: ', router)


    let queryParams = null

    if (router?.asPath.includes("?")) {
      queryParams = new URLSearchParams(router?.asPath.split('?')[1]);
    }
    
    const search = queryParams?.get('search')

    if (
      router?.query?.location &&
      router?.query?.region &&
      router?.query?.country &&
      router?.query?.lon &&
      router?.query?.lat &&
      router?.query?.area &&
      !staticList
    ) {
      dispatch({
        type: 'updateLocation',
        payload: {
          formatted_address: router?.query?.location,
          regions: {
            area: router?.query?.area,
            region: router?.query?.region,
            country: router?.query?.country,
          },
          coordinate: {
            lat: router?.query?.lat,
            lon: router?.query?.lon,
          },
        },
      })
    }

    const location = queryParams?.get('location')
    const area = queryParams?.get('area')
    const region = queryParams?.get('region')
    const country = queryParams?.get('country')
    const lat = queryParams?.get('lat')
    const lon = queryParams?.get('lon')

    if (
      location &&
      region &&
      country &&
      lon &&
      lat &&
      area &&
      (!staticList || !staticList?.length)
    ) {
      dispatch({
        type: 'updateLocation',
        payload: {
          formatted_address: location,
          regions: {
            area,
            region,
            country,
          },
          coordinate: {
            lat,
            lon,
          },
        },
      })
    }


    console.log('query: ', router?.query)
    console.log('static list: ', staticList)
    if ((router?.query?.search || search) && (!staticList || !staticList?.length)) {
      dispatch({ type: 'updateSearch', payload: router?.query?.search })
      console.log('updated search!! ', router?.query?.search)
      console.log('updated search 2: ', search)

      if (!router?.query?.search && search) {
        let otherFilterStates = getFilterOptionsAsPath(router)
        let searchState = (router?.query?.search === "null" || search === "null") ? null : search
        console.log('other filter states: ', otherFilterStates)
        dispatch({ type: 'updateSearch', payload: searchState })
        dispatch({
          type: 'setFilterStates',
          payload: { ...otherFilterStates, datePosted: DEFAULT_DATE_POSTED },
        })
      } else {
        dispatch({ type: 'updateSearch', payload: router?.query?.search })
        dispatch({
          type: 'setFilterStates',
          payload: { ...filterOptions, datePosted: DEFAULT_DATE_POSTED },
        })
      }
      console.log('updated filter options: ', filterOptions)
    }

    console.log('static list: ' , staticList)

    if (staticList?.length) {
      const { 
        searchTerm,
        formattedLocation,
        hybridremote,
        remoteoptional,
        fullremote,
        lat,
        lon,
        country,
        region,
        area
      } = staticParams;

      dispatch({
        type: 'updateLocation',
        payload: {
          formatted_address: formattedLocation,
          regions: {
            area,
            region, 
            country
          },
          coordinate: {
            lat,
            lon
          },
        },
      })      

      const updateFilters = {
        ...filterOptions,
        hybrid: hybridremote,
        fullRemote: fullremote,
      }

      dispatch({ type: 'updateSearch', payload: searchTerm })
      dispatch({
        type: 'setFilterStates',
        payload: { ...updateFilters, datePosted: DEFAULT_DATE_POSTED },
      })      
    }
    dispatch({ type: 'setFilter', payload: false })
  }, [])

  useEffect(() => {
    setUpdates(updates - 1)
    if (updates <= 0) {
      updateQueryString()
    }
  }, [state.location])

  useEffect(() => {
    console.log('updates: ', updates)
    if (updates <= 0) {
      updateQueryString()
    }

    setPage(0)
    setHasMore(true)

    console.log('updates: ', updates)
    if (updates <= 0 || !staticList || !staticList?.length) {
      getJobs(state, getVariables(state, null))
    }
  }, [
    state?.filterStates,
    state?.searchTerm,
    state?.location,
    state?.salaryMin,
    staticList
  ])

  useEffect(() => {
    if (page > 0) {
      getJobs(state, getVariables(state, page))
    }
  }, [page])
  
  function getVariables(state, page) {

    const isTermSearch = state?.searchTerm?.length > 0 && !state?.location?.formatted_address?.length
    const isLocationSearch = state?.location?.formatted_address?.length > 0 && !state?.searchTerm?.length

    if (isLocationSearch) {
      return (
        {
          variables: {
            input: {
              fulltime: state?.filterStates?.fullTime ? 'fulltime' : '',
              parttime: state?.filterStates?.partTime ? 'parttime' : '',
              contract: state?.filterStates?.contract ? 'contract' : '',
              onsite: state?.filterStates?.onsite ? 'onsite' : '',
              hybridremote: state?.filterStates?.hybrid ? 'hybridremote' : '',
              remoteoptional: state?.filterStates?.remoteOptional
                ? 'remoteoptional'
                : '',
              fullremote: state?.filterStates?.fullRemote ? 'fullremote' : '',
              intern: state?.filterStates?.intern ? 'intern' : '',
              junior: state?.filterStates?.junior ? 'junior' : '',
              midlevel: state?.filterStates?.midLevel ? 'midlevel' : '',
              senior: state?.filterStates?.senior ? 'senior' : '',
              executive: state?.filterStates?.executive ? 'executive' : '',
              salaryMin: state?.salaryMin ?? 0,
              remoteFirst: state?.filterStates?.remoteFirst ?? false,
              missionDriven: state?.filterStates?.missionDriven ?? false,
              flexibleHours: state?.filterStates?.flexibleHours ?? false,
              workFromAnywhere: state?.filterStates?.workFromAnywhere ?? false,
              datePosted: state?.filterStates?.datePosted ?? 'now-60d/d',
              country: state?.location?.regions?.country ?? '',
              region: state?.location?.regions?.region ?? '',
              area: state?.location?.regions?.area ?? '',        
              lat: state?.location?.coordinate?.lat,
              lon: state?.location?.coordinate?.lon,                    
              offset: page ? page * 10 : 0,
            },
          },
        }
      )       
    }

    if (isTermSearch) {
      return (
        {
          variables: {
            input: {
              text: state?.searchTerm,
              fulltime: state?.filterStates?.fullTime ? 'fulltime' : '',
              parttime: state?.filterStates?.partTime ? 'parttime' : '',
              contract: state?.filterStates?.contract ? 'contract' : '',
              onsite: state?.filterStates?.onsite ? 'onsite' : '',
              hybridremote: state?.filterStates?.hybrid ? 'hybridremote' : '',
              remoteoptional: state?.filterStates?.remoteOptional
                ? 'remoteoptional'
                : '',
              fullremote: state?.filterStates?.fullRemote ? 'fullremote' : '',
              intern: state?.filterStates?.intern ? 'intern' : '',
              junior: state?.filterStates?.junior ? 'junior' : '',
              midlevel: state?.filterStates?.midLevel ? 'midlevel' : '',
              senior: state?.filterStates?.senior ? 'senior' : '',
              executive: state?.filterStates?.executive ? 'executive' : '',
              salaryMin: state?.salaryMin ?? 0,
              remoteFirst: state?.filterStates?.remoteFirst ?? false,
              missionDriven: state?.filterStates?.missionDriven ?? false,
              flexibleHours: state?.filterStates?.flexibleHours ?? false,
              workFromAnywhere: state?.filterStates?.workFromAnywhere ?? false,
              datePosted: state?.filterStates?.datePosted ?? 'now-60d/d',
              offset: page ? page * 10 : 0,
            },
          },
        }
      )      
    }
    
    return (
      {
        variables: {
          input: {
            text: state?.searchTerm,
            fulltime: state?.filterStates?.fullTime ? 'fulltime' : '',
            parttime: state?.filterStates?.partTime ? 'parttime' : '',
            contract: state?.filterStates?.contract ? 'contract' : '',
            hybridremote: state?.filterStates?.hybrid ? 'hybridremote' : '',
            onsite: state?.filterStates?.onsite ? 'onsite' : '',
            remoteoptional: state?.filterStates?.remoteOptional
              ? 'remoteoptional'
              : '',
            fullremote: state?.filterStates?.fullRemote ? 'fullremote' : '',
            intern: state?.filterStates?.intern ? 'intern' : '',
            junior: state?.filterStates?.junior ? 'junior' : '',
            midlevel: state?.filterStates?.midLevel ? 'midlevel' : '',
            senior: state?.filterStates?.senior ? 'senior' : '',
            executive: state?.filterStates?.executive ? 'executive' : '',
            salaryMin: state?.salaryMin ?? 0,
            lat: state?.location?.coordinate?.lat,
            lon: state?.location?.coordinate?.lon,
            remoteFirst: state?.filterStates?.remoteFirst ?? false,
            missionDriven: state?.filterStates?.missionDriven ?? false,
            flexibleHours: state?.filterStates?.flexibleHours ?? false,
            workFromAnywhere: state?.filterStates?.workFromAnywhere ?? false,
            datePosted: state?.filterStates?.datePosted ?? 'now-60d/d',
            country: state?.location?.regions?.country ?? '',
            region: state?.location?.regions?.region ?? '',
            area: state?.location?.regions?.area ?? '',
            offset: page ? page * 10 : 0,
          },
        },
      }
    )
  }  

  useEffect(() => {
    function performUpdates(newJobs, page) {
      console.log('perform updates with jobs: ', jobs)
      if (!newJobs?.length) {
        if (!page) {
          setJobs([])
        }
        setHasMore(false)
      } else if (page) {
        setJobs([
          ...jobs,
          ...jobsWithAppliedStatus(newJobs, null),
        ])
      } else {
        setJobs(jobsWithAppliedStatus(newJobs, null))
      }

      if (newJobs?.length < 10) {
        setHasMore(false)
      }
    }
    
    if (data?.searchJobs) {
      performUpdates(data?.searchJobs, page)
    } else if (termSearchData?.searchJobsByTerm) {
      performUpdates(termSearchData?.searchJobsByTerm, page)
    } else if (locationSearchData?.searchJobsByLocation) {
      performUpdates(locationSearchData?.searchJobsByLocation, page)
    }
  }, [data?.searchJobs, termSearchData?.searchJobsByTerm, locationSearchData?.searchJobsByLocation])

  if (typeof window !== 'undefined') {
    let vh = window?.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  const handleScroll = () => {
    console.log('handle scroll: ', page)
    setPage(page + 1)
  }

  const mobilePageStyle = isTabletOrMobile
    ? {
        height: mobileHeight - 161,
        position: 'relative',
        top: 3,
      }
    : null

  const mobileContainerStyle = isTabletOrMobile
    ? {
        height: mobileHeight - 60,
      }
    : null

  return (
    <div className={styles.container} style={mobileContainerStyle}>
      {!isTabletOrMobile && <FilterBar />}
      {isTabletOrMobile && <MobileSearch hasJobs={jobs.length} />}
      <div className={styles.pageBody} style={mobilePageStyle}>
        {loading && page === 0 ? (
          <Loader
            active
            inline="centered"
            size="huge"
            className={styles.loader}
          />
        ) : (
          <JobsViewer
            jobSeekerId={jobSeekerId}
            jobPostings={jobs}
            doNotClear
            hasMore={hasMore}
            onScroll={handleScroll}
          />
        )}
      </div>
    </div>
  )
}

const getFilterOptions = (router) => {
  let appliedFilters = {}
  Object.keys(jobFilters).forEach((key) => (appliedFilters[key] = true))
  const queryFilters = Object.keys(router.query).filter(
    (key) => Object.keys(jobFilters).indexOf(key) > -1,
  )

  queryFilters.forEach((key) => {
    if (router.query?.[key] === 'false') {
      appliedFilters[key] = false
    }
  })

  return appliedFilters
}

const getFilterOptionsAsPath = (router: any) => {
  let appliedFilters: { [key: string]: boolean } = {};
  Object.keys(jobFilters).forEach((key) => (appliedFilters[key] = true));

  // Extract query parameters using URLSearchParams
  const queryParams = new URLSearchParams(router.asPath.split('?')[1]);
  const queryFilters: string[] = [];
  queryParams.forEach((value, key) => {
    if (Object.keys(jobFilters).indexOf(key) > -1) {
      queryFilters.push(key);
    }
  });

  queryFilters.forEach((key) => {
    if (queryParams.get(key) === 'false') {
      appliedFilters[key] = false;
    }
  });

  return appliedFilters;
};

const jobsWithAppliedStatus = (jobs, applicationMap) => {
  if (!applicationMap) return jobs

  let newJobs = jobs.map((job) => {
    if (applicationMap[job?.id]) {
      return {
        ...job,
        applied: true,
      }
    }
    return job
  })

  return newJobs ?? []
}
